let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let AuthedUserSession = require("../../utils/AuthedUserSession");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
//let FormMixin = require("react-loose-forms");
//let FormUtils = require("../../utils/FormUtils");
//let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");

// let NewForm = dd.createClass({
//   mixins: [FormMixin],
//   getInitialValuesSourceVersion(props) {
//     return {
//       company: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
//     };
//   },
//   getInitialValues(props) {
//     return {
//       company: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
//     };
//   },
//   buildSchema(props) {
//     return {
//       company: {
//         label: "Company",
//         type: "select",
//         placeholder: "Select a company",
//         validate: FormUtils.v.optional,
//         options: _.object(_.map(_.filter(_.get(AuthedUserSession, ["companies"]), function (company) {
//           // Only show parent companies
//           return _.get(company, ["PARENT_ID"]) === 0;
//         }), function (company) {
//           return [
//             _.get(company, ["COMPANY_ID"]),
//             _.get(company, ["NAME"])
//           ];
//         }))
//       }
//     };
//   },
//   __clickCompany(company_id) {
//     AuthedUserSession.setLastSelectedCompany(company_id);
//     window.location.reload();
//   },
//   render() {
//     let self = this;
//     let fields = this.Form_buildSchema();
//     let {onCancel} = this.props;
//     let renderFieldLayout = function (layout) {
//       return ezHorizontalFields(self, _.filter(layout, function (row) {
//         return _.size(row) === 1 ? _.has(fields, row[0]) : true;
//       }), "sm", 2);
//     };
//     return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
//       renderFieldLayout([["company"]]),
//       dd.div({className: "form-group text-center", style: {marginTop: 30}},
//         dd.button({type: "submit", className: "btn btn-primary"}, "Change Company"),
//         " ",
//         dd.button({className: "btn btn-default", onClick: onCancel}, "Cancel")
//       ));
//   }
// });

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {
      show: false,
      companies: _.get(AuthedUserSession, ["companies"])
    };
  },
  Radio_setup() {
    return {
      change_active_company() {
        this.setState({
          show: !this.state.show
        });
      }
    };
  },
  __close: esUtils.wrapPreventDefault(function () {
    this.setState({show: false});
  }),
  __onSubmit: (company) => {
    return esUtils.wrapPreventDefault(() => {
      AuthedUserSession.setLastSelectedCompany(_.get(company, ["COMPANY_ID"]));
      window.location.reload();
    });
  },
  __onClose: function () {
    this.setState({
      show: false
    });
  },
  render() {
    let {
          // companies,
          show
        } = this.state;
    if (!show) {
      return dd.div();
    }
    let cnames = _.get(AuthedUserSession, ["companies"], []);
    cnames = _.filter(cnames, function (company) {
      return _.get(company, ["PARENT_ID"]) === 0;
    });
    let that = this;
    return Modal({
        title: "Change Active Company",
        buttons: [
          {
            name: "Never mind",
            onClick: this.__onClose,
            className: "btn btn-default"
          }
        ],
      },
      dd.div({},
        dd.p({}, "You are currently on the ", dd.b({}, _.get(AuthedUserSession, ["activeCompany", "NAME"])), " company."),
        dd.div({className: 'text-center'}, dd.p({className: 'text-center btn btn-success disabled', style: {margin: "5px"}}, _.get(AuthedUserSession, ["activeCompany", "NAME"]))),
        dd.p({}, "Choose another company you want to work with:"),
        dd.div({className: 'text-center'}, _.map(_.filter(cnames, (c) => (_.get(c, "COMPANY_ID") !== _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))), function (company) {
          let classnames = "btn btn-primary";
          if (_.get(company, "COMPANY_ID") === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])) {
            classnames += " disabled";
          }
          return dd.p({key: _.get(company, "COMPANY_ID"), style:{margin: "5px"}, className: classnames, onClick: that.__onSubmit(company)}, _.get(company, ["NAME"], "???"));
        }))
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/modals/ChangeActiveCompany.js